// Dropdown cambio taglia SOPRA al selettore quantità
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    const eligibleCollectionId = 667245511004;
    const product = window.product || {};

    if (!Array.isArray(product.collections) || !product.collections.some((c) => c.id == eligibleCollectionId)) return;

    const observer = new MutationObserver(() => {
        const modal = document.querySelector(".customily-modal-container, .csh-product-customizer-modal");
        const customilyOptions = document.querySelectorAll(".customily_option");

        if (!modal || customilyOptions.length === 0) return;
        if (modal.style.display === "none") return;

        const lastOption = customilyOptions[customilyOptions.length - 1];
        const content = lastOption?.querySelector(".cl-option-content") || lastOption;

        if (content) {
            // 1. Trova tutte le taglie disponibili nel componente Globo
            const sizeContainer = document.querySelector('.swatch--gl[data-option-index="2"]');
            const sizeInputs = sizeContainer?.querySelectorAll('input[type="radio"]');
            
            if (!sizeInputs || sizeInputs.length === 0) return;

            // 2. Controlla se è "Taglia unica" (basandosi sul primo valore o sul selezionato)
            const firstSizeValue = sizeInputs[0].value.trim().toLowerCase();
            if (firstSizeValue === "taglia unica") {
                const existingContainer = content.querySelector(".custom-size-dropdown-container");
                if (existingContainer) existingContainer.remove();
                return;
            }

            // 3. Crea o aggiorna il dropdown
            let dropdownContainer = content.querySelector(".custom-size-dropdown-container");
            
            if (!dropdownContainer) {
                dropdownContainer = document.createElement("div");
                dropdownContainer.className = "custom-size-dropdown-container";
                dropdownContainer.style.marginBottom = "15px";
                dropdownContainer.style.paddingBottom = "15px";
                dropdownContainer.style.borderBottom = "1px solid #ddd";

                const label = document.createElement("label");
                label.innerText = "Taglia:";
                label.style.display = "block";
                label.style.fontWeight = "bold";
                label.style.marginBottom = "5px";
                label.style.fontSize = "14px";

                const select = document.createElement("select");
                select.className = "custom-size-select";
                select.style.width = "100%";
                select.style.padding = "8px";
                select.style.borderRadius = "4px";
                select.style.border = "1px solid #ccc";

                // Popola il dropdown con le taglie di Globo
                sizeInputs.forEach(input => {
                    const option = document.createElement("option");
                    option.value = input.value;
                    option.text = input.value;
                    if (input.checked) option.selected = true;
                    select.appendChild(option);
                });

                // Evento al cambio: clicca il radio di Globo originale
                select.addEventListener("change", (e) => {
                    const targetValue = e.target.value;
                    const radioToClick = Array.from(sizeInputs).find(i => i.value === targetValue);
                    if (radioToClick) {
                        radioToClick.click(); // Triggera l'aggiornamento di Shopify/Globo
                    }
                });

                dropdownContainer.appendChild(label);
                dropdownContainer.appendChild(select);
                content.prepend(dropdownContainer);
            } else {
                // Sincronizza il dropdown se la taglia cambia esternamente
                const currentChecked = Array.from(sizeInputs).find(i => i.checked);
                const select = dropdownContainer.querySelector("select");
                if (currentChecked && select && select.value !== currentChecked.value) {
                    select.value = currentChecked.value;
                }
            }
        }
    });

    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
});